import SortBy from  "Lib/Fs.Core.Data/SortBy";

class SortingCriteria extends Array<SortBy> {

}

export default SortingCriteria;
